module.exports = __webpack_public_path__ + "img/contact_map_background_md.8db14745.png";